export { default } from './AdvantagesSlider';
